// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"e9","bottomColumnWapper":"e9","bottom-column-panel":"e-","bottomColumnPanel":"e-"};